// src/components/Materials2.jsx
import React, { useState, useEffect } from 'react';
import categoriasData from '../../databases/camicon/materiales_categorias.json';
import materialesData from '../../databases/camicon/materiales_materiales2.json';

const SearchableDropdown = ({ 
  label, 
  options, 
  value, 
  onChange, 
  disabled = false,
  placeholder = "Seleccionar...",
  searchPlaceholder = "Buscar..."
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  
  const filteredOptions = options.filter(option =>
    option.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  

  return (
    <div className="relative">
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      <button
        type="button"
        className={`w-full p-2 border ${disabled ? 'bg-gray-100' : 'bg-white'} border-gray-300 rounded text-left flex justify-between items-center ${disabled ? 'text-gray-400' : 'text-gray-700'}`}
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
      >
        {value ? options.find(opt => opt.id === value)?.name || value : placeholder}
        <svg 
          className={`h-5 w-5 ml-2 transition-transform ${isOpen ? 'transform rotate-180' : ''}`} 
          viewBox="0 0 20 20" 
          fill="currentColor"
        >
          <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      </button>
      
      {isOpen && (
        <div className="absolute z-10 mt-1 w-full bg-white rounded-lg shadow-lg border border-gray-300">
          <div className="p-2 border-b border-gray-200">
            <input
              type="text"
              placeholder={searchPlaceholder}
              className="w-full p-2 border border-gray-300 rounded text-sm"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div>
          <div className="max-h-60 overflow-y-auto">
            <button
              className={`w-full text-left px-3 py-2 hover:bg-gray-100 text-sm ${!value ? 'bg-blue-50' : ''}`}
              onClick={() => {
                onChange('');
                setIsOpen(false);
                setSearchTerm('');
              }}
            >
              {placeholder}
            </button>
            
            {filteredOptions.map(option => (
              <button
                key={option.id}
                className={`w-full text-left px-3 py-2 hover:bg-gray-100 text-sm ${value === option.id ? 'bg-blue-50 font-medium' : ''}`}
                onClick={() => {
                  onChange(option.id);
                  setIsOpen(false);
                  setSearchTerm('');
                }}
              >
                {option.name}
              </button>
            ))}
            
            {filteredOptions.length === 0 && (
              <div className="px-3 py-2 text-gray-500 text-sm">
                No se encontraron resultados
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const Materials2 = () => 
{
  const [categories, setCategories] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [newPrice, setNewPrice] = useState('');
  const [newCurrency, setNewCurrency] = useState('USD');
  const [editMode, setEditMode] = useState(false);
  const [filteredMaterials, setFilteredMaterials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [detailView, setDetailView] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 60; // 15 rows x 4 items per row

  const [newMaterial, setNewMaterial] = useState({
    name: '',
    unit: '',
    supplier: '',
    categoryID: '',
    subcategoryID: '',
    materialID: '',
    uniqueId: Date.now()
  });

  const [filters, setFilters] = useState({
    supplier: '',
    category: '',
    subcategory: ''
  });

  // Propaganda items
  const propagandaItems = [
    {
      id: 1,
      title: "¡Oferta Especial!",
      description: "Descuentos en materiales seleccionados",
      image: "https://via.placeholder.com/300x200?text=Oferta+Especial",
      cta: "Ver Oferta"
    },
    {
      id: 2,
      title: "Nuevos Productos",
      description: "Descubre nuestra última colección",
      image: "https://via.placeholder.com/300x200?text=Nuevos+Productos",
      cta: "Explorar"
    },
    {
      id: 3,
      title: "Financiamiento",
      description: "Planes de pago especiales",
      image: "https://via.placeholder.com/300x200?text=Financiamiento",
      cta: "Más Info"
    }
  ];

  useEffect(() => {
    const loadData = async () => {
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      const materialsWithUniqueIds = materialesData.map(material => ({
        ...material,
        uniqueId: material.uniqueId || `${material.id}_${Date.now()}`
      }));
      
      setCategories(categoriasData);
      setMaterials(materialsWithUniqueIds);
      setFilteredMaterials(materialsWithUniqueIds);
      setLoading(false);
    };
    
    loadData();
  }, []);

  useEffect(() => {
    const searchWords = searchTerm.toLowerCase().split(/\s+/).filter(Boolean);
    
    let filtered = materials;
    
    if (filters.supplier) {
      filtered = filtered.filter(material => material.supplier === filters.supplier);
    }
    
    if (filters.category) {
      filtered = filtered.filter(material => material.categoryID === filters.category);
    }
    
    if (filters.subcategory) {
      filtered = filtered.filter(material => material.subcategoryID === filters.subcategory);
    }
    
    if (searchWords.length > 0) {
      filtered = filtered.filter(material => {
        const searchableText = [
          material.name,
          material.categoryName,
          material.subcategoryName,
          material.id,
          material.supplier,
          material.unit
        ].join(' ').toLowerCase();
        
        return searchWords.every(word => searchableText.includes(word));
      });
    }
    
    setFilteredMaterials(filtered);
    setCurrentPage(1);
  }, [materials, searchTerm, filters]);

  const getFilteredSuppliers = () => {
    const suppliers = new Set();
    
    if (searchTerm) {
      const searchWords = searchTerm.toLowerCase().split(/\s+/).filter(Boolean);
      materials.forEach(material => {
        const searchableText = [
          material.name,
          material.categoryName,
          material.subcategoryName,
          material.id,
          material.supplier,
          material.unit
        ].join(' ').toLowerCase();
        
        if (searchWords.every(word => searchableText.includes(word))) {
          if (material.supplier) suppliers.add(material.supplier);
        }
      });
    } else {
      materials.forEach(material => {
        if (material.supplier) suppliers.add(material.supplier);
      });
    }
    
    return Array.from(suppliers).sort((a, b) => a.localeCompare(b))
      .map(supplier => ({ id: supplier, name: supplier }));
  };

  const getFilteredCategories = () => {
    const categoryIds = new Set();
    
    if (filters.supplier || searchTerm) {
      materials.forEach(material => {
        const supplierMatch = !filters.supplier || material.supplier === filters.supplier;
        
        let searchMatch = true;
        if (searchTerm) {
          const searchWords = searchTerm.toLowerCase().split(/\s+/).filter(Boolean);
          const searchableText = [
            material.name,
            material.categoryName,
            material.subcategoryName,
            material.id,
            material.supplier,
            material.unit
          ].join(' ').toLowerCase();
          
          searchMatch = searchWords.every(word => searchableText.includes(word));
        }
        
        if (supplierMatch && searchMatch) {
          categoryIds.add(material.categoryID);
        }
      });
      
      return categories
        .filter(category => categoryIds.has(category.id))
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(category => ({ id: category.id, name: category.name }));
    }
    
    return [...categories]
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(category => ({ id: category.id, name: category.name }));
  };

  const getFilteredSubcategories = () => {
    if (!filters.category) return [];
    
    const subcategoryIds = new Set();
    
    materials.forEach(material => {
      const supplierMatch = !filters.supplier || material.supplier === filters.supplier;
      const categoryMatch = material.categoryID === filters.category;
      
      let searchMatch = true;
      if (searchTerm) {
        const searchWords = searchTerm.toLowerCase().split(/\s+/).filter(Boolean);
        const searchableText = [
          material.name,
          material.categoryName,
          material.subcategoryName,
          material.id,
          material.supplier,
          material.unit
        ].join(' ').toLowerCase();
        
        searchMatch = searchWords.every(word => searchableText.includes(word));
      }
      
      if (supplierMatch && categoryMatch && searchMatch) {
        subcategoryIds.add(material.subcategoryID);
      }
    });
    
    const category = categories.find(c => c.id === filters.category);
    if (!category || !category.subcategories) return [];
    
    return category.subcategories
      .filter(sub => subcategoryIds.has(sub.id))
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(sub => ({ id: sub.id, name: sub.name }));
  };

  const handleFilterChange = (filterName, value) => {
    setFilters(prev => {
      const newFilters = {
        ...prev,
        [filterName]: value
      };
      
      if (filterName === 'supplier') {
        newFilters.category = '';
        newFilters.subcategory = '';
      } else if (filterName === 'category') {
        newFilters.subcategory = '';
      }
      
      return newFilters;
    });
  
    setSelectedMaterial(null);
    setDetailView(false);
  };

  const handleSelectMaterial = (material) => {
    setSelectedMaterial(material);
    setEditMode(false);
    setDetailView(true);
  };

  const handleCloseDetail = (e) => {
    if (e.target === e.currentTarget) {
      setDetailView(false);
    }
  };

  const handleAddPrice = () => {
    if (!newPrice || isNaN(newPrice) || !selectedMaterial) return;

    const updatedMaterials = materials.map(material => {
      if (material.uniqueId === selectedMaterial.uniqueId) {
        const newPriceEntry = {
          cost: parseFloat(newPrice),
          currency: newCurrency,
          date: new Date().toISOString(),
          timestamp: Date.now()
        };
        return {
          ...material,
          priceHistory: [...(material.priceHistory || []), newPriceEntry]
        };
      }
      return material;
    });

    setMaterials(updatedMaterials);
    setSelectedMaterial(updatedMaterials.find(m => m.uniqueId === selectedMaterial.uniqueId));
    setNewPrice('');
  };

  const handleDownload = () => {
    const data = JSON.stringify({ categories, materials }, null, 2);
    const blob = new Blob([data], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'materiales_actualizados.json';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleCreateMaterial = () => {
    if (!newMaterial.name || !newMaterial.unit || !newMaterial.supplier || 
        !newMaterial.categoryID || !newMaterial.subcategoryID || !newMaterial.materialID) {
      alert('Por favor complete todos los campos');
      return;
    }

    const category = categories.find(c => c.id === newMaterial.categoryID);
    const subcategory = category?.subcategories?.find(s => s.id === newMaterial.subcategoryID);

    const materialId = `${newMaterial.categoryID}.${newMaterial.subcategoryID}.${newMaterial.materialID}`;
    
    const newMaterialEntry = {
      id: materialId,
      uniqueId: `${materialId}_${Date.now()}`,
      name: newMaterial.name,
      unit: newMaterial.unit,
      supplier: newMaterial.supplier,
      priceHistory: [],
      categoryName: category?.name || '',
      categoryID: newMaterial.categoryID,
      subcategoryName: subcategory?.name || '',
      subcategoryID: newMaterial.subcategoryID,
      materialID: newMaterial.materialID
    };

    const updatedMaterials = [...materials, newMaterialEntry];
    setMaterials(updatedMaterials);
    setNewMaterial({
      name: '',
      unit: '',
      supplier: '',
      categoryID: '',
      subcategoryID: '',
      materialID: '',
      uniqueId: Date.now()
    });
    setEditMode(false);
    setDetailView(false);
  };

  const totalPages = Math.ceil(filteredMaterials.length / itemsPerPage);
  const currentItems = filteredMaterials.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const getInterleavedItems = () => {
    const result = [];
    let materialIndex = 0;
    let propagandaIndex = 0;
    
    while (materialIndex < currentItems.length) {
      // Add 11 materials and 1 propaganda
      const remaining = Math.min(11, currentItems.length - materialIndex);
      for (let i = 0; i < remaining; i++) {
        result.push({
          type: 'material',
          data: currentItems[materialIndex++]
        });
      }
      
      if (materialIndex < currentItems.length) {
        result.push({
          type: 'propaganda',
          data: propagandaItems[propagandaIndex % propagandaItems.length]
        });
        propagandaIndex++;
      }
    }
    
    return result;
  };

  const PropagandaCard = ({ item }) => (
    <div className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer hover:shadow-lg transition-shadow duration-300 h-full">
      <div className="bg-gray-200 h-40 flex items-center justify-center">
        <img 
          src={item.image} 
          alt={item.title}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-4">
        <h3 className="font-semibold text-lg mb-1">{item.title}</h3>
        <p className="text-gray-600 text-sm mb-2">{item.description}</p>
        <button className="w-full bg-blue-600 text-white py-1 rounded hover:bg-blue-700 text-sm">
          {item.cta}
        </button>
      </div>
    </div>
  );

  const Paginator = () => (
    <div className="flex justify-center items-center my-4">
      <button
        onClick={() => handlePageChange(1)}
        disabled={currentPage === 1}
        className="px-3 py-1 mx-1 border rounded disabled:opacity-50"
      >
        «
      </button>
      <button
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-1 mx-1 border rounded disabled:opacity-50"
      >
        ‹
      </button>
      
      {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
        let pageNum;
        if (totalPages <= 5) {
          pageNum = i + 1;
        } else if (currentPage <= 3) {
          pageNum = i + 1;
        } else if (currentPage >= totalPages - 2) {
          pageNum = totalPages - 4 + i;
        } else {
          pageNum = currentPage - 2 + i;
        }
        
        return (
          <button
            key={pageNum}
            onClick={() => handlePageChange(pageNum)}
            className={`px-3 py-1 mx-1 border rounded ${currentPage === pageNum ? 'bg-blue-600 text-white' : ''}`}
          >
            {pageNum}
          </button>
        );
      })}
      
      {totalPages > 5 && currentPage < totalPages - 2 && (
        <span className="mx-1">...</span>
      )}
      
      {totalPages > 5 && currentPage < totalPages - 2 && (
        <button
          onClick={() => handlePageChange(totalPages)}
          className={`px-3 py-1 mx-1 border rounded ${currentPage === totalPages ? 'bg-blue-600 text-white' : ''}`}
        >
          {totalPages}
        </button>
      )}
      
      <button
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-1 mx-1 border rounded disabled:opacity-50"
      >
        ›
      </button>
      <button
        onClick={() => handlePageChange(totalPages)}
        disabled={currentPage === totalPages}
        className="px-3 py-1 mx-1 border rounded disabled:opacity-50"
      >
        »
      </button>
    </div>
  );

  const roundTo2 = (num) => Math.round(num * 100) / 100;

  if (loading) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
        <div className="text-center">
          <p className="text-white text-xl mb-4">Cargando materiales...</p>
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-white mx-auto"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4">
      <div className="mb-6 space-y-4 bg-white p-4 rounded-lg shadow">
        <input
          type="text"
          placeholder="Buscar materiales (nombre, categoría, proveedor)..."
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <SearchableDropdown
              label="Proveedor"
              options={[
                { id: '', name: 'Todos los proveedores' },
                ...getFilteredSuppliers()
              ]}
              value={filters.supplier}
              onChange={(value) => handleFilterChange('supplier', value)}
              placeholder="Todos los proveedores"
              searchPlaceholder="Buscar proveedor..."
            />
          </div>
          
          <div>
            <SearchableDropdown
              label="Categoría"
              options={[
                { id: '', name: 'Todas las categorías' },
                ...getFilteredCategories()
              ]}
              value={filters.category}
              onChange={(value) => handleFilterChange('category', value)}
              disabled={!!filters.supplier}
              placeholder={filters.supplier ? 'Seleccione proveedor primero' : 'Todas las categorías'}
              searchPlaceholder="Buscar categoría..."
            />
          </div>
          
          <div>
            <SearchableDropdown
              label="Subcategoría"
              options={[
                { id: '', name: 'Todas las subcategorías' },
                ...getFilteredSubcategories()
              ]}
              value={filters.subcategory}
              onChange={(value) => handleFilterChange('subcategory', value)}
              disabled={!filters.category}
              placeholder={filters.category ? 'Todas las subcategorías' : 'Seleccione categoría primero'}
              searchPlaceholder="Buscar subcategoría..."
            />
          </div>
        </div>
      </div>
      
      {filteredMaterials.length > 0 && <Paginator />}
      
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">
        {getInterleavedItems().map((item, index) => (
          item.type === 'material' ? (
            <div 
              key={`material-${item.data.uniqueId}`}
              className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer hover:shadow-lg transition-shadow duration-300 h-full"
              onClick={() => handleSelectMaterial(item.data)}
            >
              <div className="bg-gray-200 h-40 flex items-center justify-center">
                <svg className="w-20 h-20 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                </svg>
              </div>
              
              <div className="p-4">
                <h3 className="font-semibold text-lg mb-1 truncate">{item.data.name}</h3>
                <p className="text-gray-600 text-sm mb-2">
                  {item.data.categoryName} / {item.data.subcategoryName}
                </p>
                
                {item.data.priceHistory?.length > 0 ? (
                  <div>
                    <p className="text-xl font-bold text-blue-600">
                      ${roundTo2(item.data.priceHistory[item.data.priceHistory.length - 1].cost)} {item.data.priceHistory[item.data.priceHistory.length - 1].currency}
                    </p>
                    <p className="text-gray-500 text-xs">
                      {new Date(item.data.priceHistory[item.data.priceHistory.length - 1].date).toLocaleDateString()} | {item.data.unit}
                    </p>
                  </div>
                ) : (
                  <p className="text-red-500 text-sm">Sin precios registrados</p>
                )}
              </div>
            </div>
          ) : (
            <div key={`propaganda-${item.data.id}-${index}`} className="h-full">
              <PropagandaCard item={item.data} />
            </div>
          )
        ))}
      </div>

      {filteredMaterials.length > 0 && <Paginator />}
      
      {detailView && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4"
          onClick={handleCloseDetail}
        >
          <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            {editMode && !selectedMaterial ? (
              <div className="p-6">
                <h2 className="text-xl font-semibold mb-4">Nuevo Material</h2>
                
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Nombre</label>
                    <input
                      type="text"
                      className="w-full p-2 border border-gray-300 rounded"
                      value={newMaterial.name}
                      onChange={(e) => setNewMaterial({...newMaterial, name: e.target.value})}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Unidad</label>
                    <input
                      type="text"
                      className="w-full p-2 border border-gray-300 rounded"
                      value={newMaterial.unit}
                      onChange={(e) => setNewMaterial({...newMaterial, unit: e.target.value})}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Proveedor</label>
                    <input
                      type="text"
                      className="w-full p-2 border border-gray-300 rounded"
                      value={newMaterial.supplier}
                      onChange={(e) => setNewMaterial({...newMaterial, supplier: e.target.value})}
                    />
                  </div>
                  <div>
                    <SearchableDropdown
                      label="Categoría"
                      options={getFilteredCategories()}
                      value={newMaterial.categoryID}
                      onChange={(value) => setNewMaterial({...newMaterial, categoryID: value, subcategoryID: ''})}
                      placeholder="Seleccionar categoría"
                      searchPlaceholder="Buscar categoría..."
                    />
                  </div>
                  {newMaterial.categoryID && (
                    <div>
                      <SearchableDropdown
                        label="Subcategoría"
                        options={categories.find(c => c.id === newMaterial.categoryID)?.subcategories?.sort((a, b) => a.name.localeCompare(b.name)).map(sub => ({ id: sub.id, name: sub.name })) || []}
                        value={newMaterial.subcategoryID}
                        onChange={(value) => setNewMaterial({...newMaterial, subcategoryID: value})}
                        placeholder="Seleccionar subcategoría"
                        searchPlaceholder="Buscar subcategoría..."
                      />
                    </div>
                  )}
                  <div>
                    <label className="block text-sm font-medium text-gray-700">ID de Material</label>
                    <input
                      type="text"
                      className="w-full p-2 border border-gray-300 rounded"
                      value={newMaterial.materialID}
                      onChange={(e) => setNewMaterial({...newMaterial, materialID: e.target.value})}
                    />
                  </div>
                  <div className="flex gap-2 justify-end">
                    <button
                      className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                      onClick={() => setDetailView(false)}
                    >
                      Cancelar
                    </button>
                    <button
                      className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                      onClick={handleCreateMaterial}
                    >
                      Guardar Material
                    </button>
                  </div>
                </div>
              </div>
            ) : selectedMaterial ? (
              <div className="p-6">
                <div className="flex justify-between items-start mb-4">
                  <h2 className="text-xl font-semibold">{selectedMaterial.name}</h2>
                  <button 
                    onClick={() => setDetailView(false)}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                  </button>
                </div>
                
                <div className="bg-gray-200 h-48 rounded-lg mb-4 flex items-center justify-center">
                  <svg className="w-20 h-20 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                  </svg>
                </div>
                
                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div>
                    <h3 className="text-sm font-medium text-gray-500">Categoría</h3>
                    <p className="font-medium">{selectedMaterial.categoryName || 'N/A'}</p>
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-gray-500">Subcategoría</h3>
                    <p className="font-medium">{selectedMaterial.subcategoryName || 'N/A'}</p>
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-gray-500">Unidad</h3>
                    <p className="font-medium">{selectedMaterial.unit || 'N/A'}</p>
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-gray-500">Proveedor</h3>
                    <p className="font-medium">{selectedMaterial.supplier || 'N/A'}</p>
                  </div>
                  <div className="col-span-2">
                    <h3 className="text-sm font-medium text-gray-500">ID Completo</h3>
                    <p className="font-mono bg-gray-100 p-2 rounded">{selectedMaterial.id || 'N/A'}</p>
                  </div>
                </div>
                
                <div className="mb-6">
                  <h3 className="text-lg font-semibold mb-3">Historial de Precios</h3>
                  {selectedMaterial.priceHistory?.length > 0 ? (
                    <div className="bg-gray-50 rounded-lg p-3 max-h-60 overflow-y-auto">
                      <table className="w-full">
                        <thead>
                          <tr className="border-b border-gray-200">
                            <th className="text-left py-2 text-sm font-medium text-gray-500">Fecha</th>
                            <th className="text-right py-2 text-sm font-medium text-gray-500">Precio</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedMaterial.priceHistory.map((price, index) => (
                            <tr key={index} className="border-b border-gray-200 last:border-0">
                              <td className="py-2 text-sm">{new Date(price.date).toLocaleDateString()}</td>
                              <td className="py-2 text-right font-medium">
                                {price.cost} {price.currency}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p className="text-gray-500 text-center py-4">No hay historial de precios registrado</p>
                  )}
                </div>
                
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h3 className="font-medium mb-2">Agregar Nuevo Precio</h3>
                  <div className="flex gap-2">
                    <input
                      type="number"
                      step="0.01"
                      placeholder="Nuevo precio"
                      className="flex-1 p-2 border border-gray-300 rounded"
                      value={newPrice}
                      onChange={(e) => setNewPrice(e.target.value)}
                    />
                    <select
                      className="p-2 border border-gray-300 rounded"
                      value={newCurrency}
                      onChange={(e) => setNewCurrency(e.target.value)}
                    >
                      <option value="USD">USD</option>
                      <option value="EUR">EUR</option>
                    </select>
                    <button
                      className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                      onClick={handleAddPrice}
                    >
                      Agregar
                    </button>
                  </div>
                </div>
                
                <div className="mt-4 flex justify-between">
                  <button
                    className="text-blue-600 hover:text-blue-800"
                    onClick={() => {
                      setEditMode(true);
                      setNewMaterial({
                        name: selectedMaterial.name,
                        unit: selectedMaterial.unit,
                        supplier: selectedMaterial.supplier,
                        categoryID: selectedMaterial.categoryID,
                        subcategoryID: selectedMaterial.subcategoryID,
                        materialID: selectedMaterial.materialID,
                        uniqueId: selectedMaterial.uniqueId
                      });
                    }}
                  >
                    Editar Material
                  </button>
                  <button
                    className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700"
                    onClick={handleDownload}
                  >
                    Exportar Datos
                  </button>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};

export default Materials2;